import { Action, createReducer, on } from '@ngrx/store';
// import {PharmacyStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import { editPharmacy, loadPharmacies, paginatePharmacies, removeAllPharmacies, removePharmacies } from 'src/actions/user/pharmacy.action';

export const initialState: any = {
  fetching: false,
  data: {
    pharmacies: [],
    totalDocuments: 0
  }
};

const pharmaciesReducer = createReducer(initialState,
  on(loadPharmacies, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacies: [
          ...state.data.pharmacies,
          ...payload.filter(p => !state.data.pharmacies.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editPharmacy, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacies: state.data.pharmacies.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removePharmacies, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacies: state.data.pharmacies
          .filter((d: any) => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllPharmacies, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        pharmacies: [],
        totalDocuments: 0
      }
    }
  )
  ),
  on(paginatePharmacies, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return pharmaciesReducer(state, action);
}
